import React from "react";
import "../../css/lp-sect-three.css";
import ExamList from "../ExamList";
import RowOneIll from "../../assets/images/lp-sect3-ill1-img.png";
import RowTwoIll from "../../assets/images/lp-sect3-ill2-img.png";
import RowThreeIll from "../../assets/images/lp-sect3-ill3-img.png";
import RowFourIll from "../../assets/images/lp-sect3-ill4-img.png";

const Sect3 = () => {
  return (
    <section id="lp-sect-3">
      <div>
        <div>
          <article>
            <h2>The best place to prepare for your certificate exam</h2>
            <div id="sect3-exam-list-cont">
              <ExamList />
            </div>
            <img id="sect3-ill1" src={RowOneIll} alt="" />
            <span>
              You don't have to re-write any exam, pass once and for all
            </span>
            <button>Get started</button>
          </article>
        </div>
        <div className="flexed-sect3-div">
          <img id="sect3-ill2" src={RowTwoIll} alt="" />
          <article>
            <h3>
              Learn at your convenience, in-school, at home, anywhere, anytime
            </h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pharetra,
              mi enim et auctor sapien cras cum rutrum.
            </p>
          </article>
        </div>
        <div className="flexed-sect3-div">
          <img id="sect3-ill3" src={RowThreeIll} alt="" />
          <article>
            <h3>
              Create your personal study time-table, we'll do the rest to help
              you study
            </h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pharetra,
              mi enim et auctor sapien cras
            </p>
          </article>
        </div>
        <div className="flexed-sect3-div">
          <img id="sect3-ill4" src={RowFourIll} alt="" />
          <article>
            <h3>
              Learn from experienced teachers with proven student success in
              exams
            </h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pharetra,
              mi enim et auctor sapien cras cum rutrum.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Sect3;
